var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-popup',{attrs:{"push":""}},[_c('f7-view',{attrs:{"name":"popup","url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }